/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import styled from "@emotion/styled";
import { colors } from "@utils/ui_palette";
import { IModule } from "@pages/AssessmentDetail";
import DefaultModal from "../modal/DefaultModal";

interface IPatterns {
  type: string;
  item: IModule;
  anwserCallback: (item: IModule, type: string) => Promise<void>;
}

function DefaultModule({ type, item, anwserCallback }: IPatterns) {
  const [modal, setModal] = useState<boolean>(false);

  const handleModal = useCallback(
    (state: boolean) => {
      setModal(state);
    },
    [setModal]
  );

  const getQuestionState = useCallback(() => {
    const anwserArr = item.anwser.toLocaleLowerCase().split(",");

    const getAnwser =
      anwserArr.filter((anwser) =>
        item.answer_submit?.toLocaleLowerCase()?.includes(anwser)
      ).length || 0;

    return getAnwser === 0 ? false : true;
  }, [item]);
  return (
    <>
      <Container
        key={`report-${type}-${item.id}`}
        active={getQuestionState()}
        type={type}
        onClick={() => handleModal(true)}
      >
        <Question>
          {item.question && item.question
            ? item.question.replace(/,/g, " ")
            : ""}
        </Question>

        <UserAnwser>
          {(item.answer_submit && item.answer_submit.replace(/,/g, " ")) || ""}
        </UserAnwser>
      </Container>
      {modal && (
        <DefaultModal
          item={item}
          type={type}
          handleModal={handleModal}
          callback={anwserCallback}
        />
      )}
    </>
  );
}

const Container = styled.div<{ active: boolean; type: string }>`
  flex-basis: ${(props) =>
    props.type === "Sequence" || props.type === "Complete_the_sentence"
      ? "100%"
      : "20%"};
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 12px;
  background-color: ${colors.White};
  border: ${(props) =>
    `${props.active ? "1px" : "2px"} solid ${
      props.active ? colors.Gray30 : colors.Error20
    };`};
  box-shadow: 5px 5px 10px ${colors.Gray30};
  margin-right: 20px;
  cursor: pointer;
`;

const Question = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  border: 1px solid ${colors.Gray30};
  border-radius: 8px;
  font-size: 24px;
  font-weight: 700;
  margin: 0 auto;
  padding: 20px;
`;

const UserAnwser = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.Primary50};
  font-weight: 700;
  font-size: 20px;
  margin-top: 20px;
`;

export default DefaultModule;
